import { Key, useRef, useState } from 'react';
import classnames from 'classnames';
import { Popover, PopoverContent, PopoverTrigger } from '@ds';
import { DropdownActionList } from './DropdownActionList';
import { NestedDropdownProps } from './types';

export const DropdownActionMenu = ({
  trigger,
  items,
  disabledKeys,
  selectedKeys,
  onAction,
  placement = 'bottom-start',
  className,
  classNames: slots,
}: NestedDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const lastActionRef = useRef<Key | null>(null);

  const handleAction = (key: Key) => {
    if (lastActionRef.current === key) {
      return;
    }

    lastActionRef.current = key;

    onAction?.(key);

    requestAnimationFrame(() => {
      lastActionRef.current = null;
    });
  };

  return (
    <Popover
      onClick={(e) => e.stopPropagation()}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      placement={placement}
      showArrow={false}
      className={className}
      // Open as a modal popover so an outside click closes the menu and is not
      // passed through to elements behind it. `backdrop` must be non-transparent
      // for HeroUI to render the backdrop element; keep it visually transparent.
      isNonModal={false}
      backdrop="opaque"
      classNames={{ backdrop: 'bg-transparent' }}
    >
      <PopoverTrigger>{trigger}</PopoverTrigger>

      <PopoverContent
        className={classnames(
          'max-w-none! flex w-full flex-col gap-0.5 outline-none bg-base-60 p-1 rounded-lg shadow-xl relative *:text-m-r!',
          slots?.base,
          slots?.content,
        )}
      >
        <DropdownActionList
          items={items}
          disabledKeys={disabledKeys}
          selectedKeys={selectedKeys}
          closeRoot={() => setIsOpen(false)}
          onAction={handleAction}
          classNames={slots}
        />
      </PopoverContent>
    </Popover>
  );
};
